import React from 'react';

import EditReportType from './EditReportType';
import AdminLayout from '../../../components/Layout/AdminLayout';
import messages from '../../../locale/jsonMessages';

export default async function action({ store, params, intl }) {

    const title = intl?.formatMessage(messages.reportTypeManagement);
    const isActiveLanguages = store?.getState()?.runtime?.isActiveLanguages

    let isAdminAuthenticated

    isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }

    return {
        title,
        component: <AdminLayout><EditReportType title={title} id={params?.id} isActiveLanguages={isActiveLanguages}/></AdminLayout>,
    };
}

